/** Private utilities */


/**
 * Detect browser scroll geometry.
 * On some systems (macOS), bar width and height may change on the fly.
 */
export function scrollProps() {
    const body = document.body;
    const outer = document.createElement('div');
    const inner = outer.cloneNode();

    outer.style.direction = 'rtl';
    outer.style.overflow = 'scroll';
    outer.style.width =
    outer.style.height = '64px';
    inner.style.width =
    inner.style.height = '128px';
    outer.appendChild(inner);
    body.appendChild(outer);

    const barWidth = outer.offsetWidth - outer.clientWidth;
    const barHeight = outer.offsetHeight - outer.clientHeight;
    const rtlBase = outer.scrollLeft ? 1 : 0;
    outer.scrollLeft = -1;
    const rtlMin = outer.scrollLeft;
    body.removeChild(outer);

    return {
        barWidth,
        barHeight,
        rtlBase,
        rtlStep: rtlBase || rtlMin < 0 ? -1 : 1
    };
}
